import React from 'react';
import { useIntl } from '@/i18n/hooks/useIntl';
import { default as Msg } from '@/i18n/components/FormattedMessage';

export const CustomerService = () => {
  const { t } = useIntl();

  return (
    <>
      <div role='heading' aria-level={5} className='font-heading-xsmall-regular margin-bottom-m'>
        <Msg id='customerService.headline' defaultMessage='Further questions?' />
      </div>
      <div className='margin-bottom-m'>
        <Msg id='customerService.text' defaultMessage='Reach out to our customer service' />
      </div>
      <div>
        <a href={`mailto:${t({ id: 'customerService.eMail', defaultMessage: 'E-Mail' })}`}>
          <span className='is24-icon-message-email margin-right-s' />
          <Msg id='customerService.eMail' defaultMessage='E-Mail' />
        </a>
      </div>
    </>
  );
};
